import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import { cn } from '@/utils/cn';
import { ShowAllButtonGlow } from './ShowAllButtonGlow';

type ShowAllButtonProps = {
  href: string;
  className?: string;
};

export const ShowAllButton = ({ href, className }: ShowAllButtonProps) => {
  const t = useTranslations('lobby.filters');

  return (
    <Link
      href={href}
      scroll={true}
      prefetch={false}
      className={cn(
        'group show-all-button relative flex h-40 items-center justify-center overflow-hidden rounded-xl transition-transform hover:scale-105',
        className,
      )}
    >
      <ShowAllButtonGlow className="pointer-events-none absolute inset-0 z-0" />

      {/* Centered label */}
      <p className="paragraph-s-medium absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-white text-center">
        {t('show-all')}
      </p>
    </Link>
  );
};
